<template>
  <fragment>
    <div class="p-banner p-banner__hl-points p-image-container-fade-in">
      <div class="p-container">
        <div class="p-banner--text">
          <img class="p-banner__illustration p-image-container-fade-in--content" src="@/assets/images/hl-points.png">
          <h1 class="p-banner--tall-heading p-image-container-fade-in--content">
            {{$t('points.banner-title')}}
          </h1>
          <p class="p-banner--text--body p-image-container-fade-in--content" v-html="$t('points.banner-content')"></p>
        </div>
      </div>
    </div>

    <div class="p-horizontal-full-width-tab p-horizontal-full-width-tab__hl-points" id="i-hl-cashback-points-tabs">
      <div class="p-horizontal-full-width-tab--tab-selectors">
        <div class="p-horizontal-full-width-tab--tab-selector active toggler" id="about-cashback-selector"
          data-toggle-class="active open" data-toggle-target="#about-cashback"
          data-toggle-on-active-match-height="#hl-points-tab-container" data-toggle-group="hl-points-tab-block"
          data-toggle-self-off-disabled="true" v-html="$t('points.cashbacks.tab-name')">
        </div>
        <div class="p-horizontal-full-width-tab--tab-selector toggler" id="about-hl-points-selector"
          data-toggle-class="active open" data-toggle-target="#about-hl-points"
          data-toggle-on-active-match-height="#hl-points-tab-container" data-toggle-group="hl-points-tab-block"
          data-toggle-self-off-disabled="true" v-html="$t('points.highlow.tab-name')">
        </div>
      </div>
      <div class="p-horizontal-full-width-tab--tab-container" id="hl-points-tab-container" style="height: 2305px;">

        <div class="p-horizontal-full-width-tab--tab active" id="about-cashback"
          data-toggle-group="hl-points-tab-block">
          <div class="p-horizontal-full-width-tab--mobile-heading">
            {{$t('points.cashbacks.mobile-title')}}
            <span class="p-horizontal-full-width-tab--mobile-close toggler" data-toggle-class="active open"
              data-toggle-target="#about-cashback">
            </span>
          </div>
          <div class="p-horizontal-full-width-tab--mobile-wrapper-block">
            <div class="p-horizontal-full-width-tab--mobile-inner-wrapper-block">
              <div class="p-horizontal-full-width-tab--block">

                <div class="p-container">
                  <h2 class="p-horizontal-full-width-tab--tab--heading">
                    {{$t('points.cashbacks.title-1')}}
                  </h2>
                  <p class="p-horizontal-full-width-tab--tab--body-text">
                    {{$t('points.cashbacks.content-1')}}
                  </p>
                  <div class="i-cashback-explain-widget" id="i-cashback-explain-widget" data-start-account="100"
                    data-cashback="100" data-trade="100" data-currency="$"
                    data-start-account-caption=" You have {s} in your <br/> Trading account "
                    data-cashback-caption=" You have a {s} cash<br/>back available "
                    data-trade-caption=" You invest {s}, <br/>paying 2.00 "
                    data-trade-won-caption=" Your investment<br/> returned {s} "
                    data-trade-lost-caption=" Your investment<br/> lost you {s} "
                    data-trade-effect-won-caption=" Add {s} to your <br/>Trading account "
                    data-trade-effect-lost-caption=" Subtract {s} from your <br/>Trading account "
                    data-account-after-trade-won-caption=" You now have {s} in your Trading account "
                    data-account-after-trade-lost-caption=" You now have {s} in your Trading account "
                    data-cashback-effect-caption=" Cash-back matches <br/>your investment "
                    data-account-final-caption=" You now have {s} in<br/> your Trading account "
                    data-cashback-final-caption=" You now have {s} <br/>cashback available ">

                    <div class="i-cashback-explain-widget--bg">
                    </div>
                    <div class="i-cashback-explain-widget--content" id="i-cashback-explain-widget--interactive-block">
                      <div class="i-cashback-explain-widget--interactive-block">
                        <div class="i-cashback-explain-widget--interactive-block--inner-wrap">
                          <div class="i-cashback-explain-widget--interactive-block--heading">
                            {{$t('points.cashbacks.widget.account-header')}}
                          </div>
                          <div class="i-cashback-explain-widget--interactive-block--heading"
                            id="i-cashback-explain-widget--trade-heading">
                            {{$t('points.cashbacks.widget.trade-header')}}
                          </div>
                          <div class="i-cashback-explain-widget--interactive-block--heading"
                            id="i-cashback-explain-widget--result-heading">
                            {{$t('points.cashbacks.widget.result-header')}}
                          </div>
                        </div>
                        <div class="i-cashback-explain-widget--interactive-block--inner-wrap">
                          <div class="i-cashback-explain-widget--interactive-block--body">
                            <div class="i-cashback-explain-widget--interactive-block--graphic-item">
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--graphic"
                                id="i-cashback-circle-1">
                                <div class="p-css-table p-css-table__fill">
                                  <div class="p-css-table-row">
                                    <div class="p-css-table-cell p-css-table-cell__bottom">
                                      <img src="@/assets/images/bank-md.png" id="i-cashback-explain-widget--bank">
                                      <div
                                        class="i-cashback-explain-widget--interactive-block--graphic-item--graphic--main-label eng"
                                        id="i-cashback-money-1">$100</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--label"
                                id="i-cashback-caption-1" v-html="$t('points.cashbacks.widget.account-caption-1')"></div>
                            </div>
                            <img src="@/assets/images/plus-gray-md.png"
                              id="i-cashback-explain-widget--interactive-block--plus" alt="plus">
                            <div class="i-cashback-explain-widget--interactive-block--graphic-item">
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--graphic"
                                id="i-cashback-circle-2">
                                <div class="p-css-table p-css-table__fill">
                                  <div class="p-css-table-row">
                                    <div class="p-css-table-cell p-css-table-cell__bottom">
                                      <img src="@/assets/images/money-md.png" id="i-cashback-explain-widget--money">
                                      <div
                                        class="i-cashback-explain-widget--interactive-block--graphic-item--graphic--main-label eng"
                                        id="i-cashback-money-2">$100</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="i-cashback-explain-widget--interactive-block--graphic-item--graphic"
                                  id="i-cashback-circle-4" style="">
                                  <div class="p-css-table p-css-table__fill">
                                    <div class="p-css-table-row">
                                      <div class="p-css-table-cell p-css-table-cell__bottom">
                                        <div
                                          class="i-cashback-explain-widget--interactive-block--graphic-item--graphic--main-label eng"
                                          id="i-cashback-cashback-amount">$100</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--label"
                                id="i-cashback-caption-2" v-html="$t('points.cashbacks.widget.account-caption-2')">  </div>
                            </div>
                          </div>
                          <div class="i-cashback-explain-widget--interactive-block--body"
                            id="i-cashback-explain-widget--trade-body">
                            <div class="i-cashback-explain-widget--interactive-block--graphic-item">
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--graphic"
                                id="i-cashback-circle-3" style="">
                                <div class="p-css-table p-css-table__fill">
                                  <div class="p-css-table-row">
                                    <div class="p-css-table-cell p-css-table-cell__center">
                                      <span id="i-cashback-explain-widget--trade-body--rate">
                                        <div class="i-cashback-explain-widget--interactive-block--graphic--label eng">
                                          AUD/USD</div>
                                        <div
                                          class="i-cashback-explain-widget--interactive-block--graphic--sub-label eng">@
                                          2.00</div>
                                      </span>
                                      <div
                                        class="i-cashback-explain-widget--interactive-block--graphic-item--graphic--main-label eng"
                                        id="i-cashback-explain-widget--trade-body--money">$100</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="i-cashback-explain-widget--interactive-block--graphic-item--label"
                                id="i-cashback-caption-3" v-html="$t('points.cashbacks.widget.trade-caption')"></div>
                            </div>
                          </div>
                          <div class="i-cashback-explain-widget--interactive-block--body"
                            id="i-cashback-explain-widget--result-body">
                            <div class="i-cashback-explain-widget--interactive-block--button win"
                              id="i-cashback-explain-widget--win">
                              {{$t('points.cashbacks.widget.win')}}
                              <span class="icon">
                              </span>
                            </div>
                            <br>
                            <div class="i-cashback-explain-widget--interactive-block--button lose">
                              {{$t('points.cashbacks.widget.lose')}}
                              <span class="icon">
                              </span>
                            </div>
                            <br>
                            <span class="i-cashback-explain-widget--interactive-block--graphic-item--label"
                              id="i-cashback-reset">
                              {{$t('points.cashbacks.widget.reset')}}
                            </span>
                            <span class="i-cashback-explain-widget--interactive-block--graphic-item--label"
                              id="i-cashback-caption-4" v-html="$t('points.cashbacks.widget.result-caption')">
                            </span>
                            <div class="i-cashback-explain-widget--slug">
                              {{$t('points.try')}}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="i-cashback-explain-widget--foot-note">
                        {{$t('points.cashbacks.widget.caption')}}
                      </div>
                    </div>
                  </div>
                  <p class="p-horizontal-full-width-tab--tab--body-text">
                    <em>{{$t('points.cashbacks.title-2')}}</em>
                  </p>
                  <p class="p-horizontal-full-width-tab--tab--body-text">{{$t('points.cashbacks.content-2')}}</p>
                  <blockquote class="p-horizontal-full-width-tab--tab--quote">
                    {{$t('points.cashbacks.quote')}}
                  </blockquote>
                </div>
              </div>
              <div class="p-horizontal-full-width-tab--block p-horizontal-full-width-tab--block__alternate-bg">
                <div class="p-container">
                  <h2 class="p-horizontal-full-width-tab--tab--heading">
                    {{$t('points.cashbacks.expectation.question')}}
                  </h2>
                  <div class="i-cashback-rules">
                    <div class="p-css-table">
                      <div class="p-css-table-row">
                        <div class="p-css-table-cell p-css-table-cell__centered i-cashback-rule">
                          <div class="i-cashback-rule--content shine-icon-container">
                            <div class="content">
                              <div class="icon shine-icon add-account">
                                <div class="default">
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                                <div class="hover">
                                  <div class="shine">
                                  </div>
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                              </div>
                              <h3 class="i-cashback-rule--heading">
                                {{$t('points.cashbacks.expectation.options.aft-title')}}
                              </h3>
                              <p class="i-cashback-rule--body-text">
                                {{$t('points.cashbacks.expectation.options.aft-content')}}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="p-css-table-cell p-css-table-cell__centered i-cashback-rule">
                          <div class="i-cashback-rule--content shine-icon-container">
                            <div class="content">
                              <div class="icon shine-icon chart">
                                <div class="default">
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                                <div class="hover">
                                  <div class="shine">
                                  </div>
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                              </div>
                              <h3 class="i-cashback-rule--heading">
                                {{$t('points.cashbacks.expectation.options.ovt-title')}}
                              </h3>
                              <p class="i-cashback-rule--body-text" v-html="$t('points.cashbacks.expectation.options.ovt-content')">
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="p-css-table-cell p-css-table-cell__centered i-cashback-rule">
                          <div class="i-cashback-rule--content shine-icon-container">
                            <div class="content">
                              <div class="icon shine-icon high-low">
                                <div class="default">
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                                <div class="hover">
                                  <div class="shine">
                                  </div>
                                  <img src="@/assets/images/cashback-rules.png">
                                </div>
                              </div>
                              <h3 class="i-cashback-rule--heading">
                                {{$t('points.cashbacks.expectation.options.oab-title')}}
                              </h3>
                              <p class="i-cashback-rule--body-text">
                                {{$t('points.cashbacks.expectation.options.oab-content')}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="i-cashback-slide-show" data-interval="5000">
                    <div class="i-cashback-slide-show--slides" id="i-cashback-slide-show--slides"
                      style="height: 410px;">
                      <div class="i-cashback-slide-show--slide" id="cashback-slide-1"
                        data-toggle-group="cashback-slides">
                        <img src="@/assets/images/cashback-screenshot-1.png" class="i-cashback-slide-show--img">
                        <div class="i-cashback-slide-show--caption">
                          {{$t('points.cashbacks.slide-caption.one')}}
                        </div>
                      </div>
                      <div class="i-cashback-slide-show--slide" id="cashback-slide-2"
                        data-toggle-group="cashback-slides">
                        <img src="@/assets/images/cashback-screenshot-2.png" class="i-cashback-slide-show--img">
                        <div class="i-cashback-slide-show--caption">
                          {{$t('points.cashbacks.slide-caption.two')}}
                        </div>
                      </div>
                      <div class="i-cashback-slide-show--slide active" id="cashback-slide-3"
                        data-toggle-group="cashback-slides">
                        <img src="@/assets/images/cashback-screenshot-3.png" class="i-cashback-slide-show--img">
                        <div class="i-cashback-slide-show--caption">
                          {{$t('points.cashbacks.slide-caption.three')}}
                        </div>
                      </div>
                    </div>
                    <div class="i-cashback-slide-show--slides-selectors">
                      <div class="i-cashback-slide-show--slides-selector toggler" data-toggle-class="active"
                        data-toggle-target="#cashback-slide-1"
                        data-toggle-on-active-match-height="#i-cashback-slide-show--slides"
                        data-toggle-group="cashback-slides" data-toggle-self-off-disabled="true">
                      </div>
                      <div class="i-cashback-slide-show--slides-selector toggler" data-toggle-class="active"
                        data-toggle-target="#cashback-slide-2"
                        data-toggle-on-active-match-height="#i-cashback-slide-show--slides"
                        data-toggle-group="cashback-slides" data-toggle-self-off-disabled="true">
                      </div>
                      <div class="i-cashback-slide-show--slides-selector toggler active" data-toggle-class="active"
                        data-toggle-target="#cashback-slide-3"
                        data-toggle-on-active-match-height="#i-cashback-slide-show--slides"
                        data-toggle-group="cashback-slides" data-toggle-self-off-disabled="true">
                      </div>
                    </div>
                  </div> <a class="p-click-scroll-to toggler p-horizontal-full-width-tab__hl-points--switch-toggle"
                    data-click-also="#about-hl-points-selector" data-click-scroll-to-target="#i-hl-cashback-points-tabs"
                    data-click-scroll-to-duration="125">
                    {{$t('points.highlow-link')}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-horizontal-full-width-tab--tab" id="about-hl-points" data-toggle-group="hl-points-tab-block">
          <div class="p-horizontal-full-width-tab--mobile-heading">
            {{$t('points.highlow.mobile-title')}}
            <span class="p-horizontal-full-width-tab--mobile-close toggler" data-toggle-class="active open"
              data-toggle-target="#about-hl-points">
            </span>
          </div>
          <div class="p-horizontal-full-width-tab--mobile-wrapper-block">
            <div class="p-horizontal-full-width-tab--mobile-inner-wrapper-block">
              <div class="p-horizontal-full-width-tab--block">
                <div class="p-container">
                  <h2 class="p-horizontal-full-width-tab--tab--heading">
                    {{$t('points.highlow.title-1')}}
                  </h2>
                  <img src="@/assets/images/mock-hl-points_new.png" id="i-hl-points--mockup">
                  <p class="p-horizontal-full-width-tab--tab--body-text">
                    {{$t('points.highlow.content-1')}}
                  </p>
                </div>
              </div>
              <div class="p-horizontal-full-width-tab--block p-horizontal-full-width-tab--block__alternate-bg-2"
                id="i-hl-points-tiers-wrapper">
                <div class="i-hl-points-tiers">
                  <div id="i-hl-points-tiers--illustration">
                    <span id="i-hl-points-tiers--title">
                      {{$t('points.highlow.tier-illustration.header')}}
                    </span>
                    <img src="@/assets/images/hl-points-symbol.png" id="i-hl-points-tiers--main-symbol">
                    <div class="i-hl-points-tier i-hl-points-tier__1">
                      <div class="p-css-table p-css-table__fill">
                        <div class="p-css-table-row">
                          <div class="p-css-table-cell p-css-table-cell__center">
                            <div class="i-hl-points-tier--index">
                              {{$t('points.highlow.tier-illustration.tier-one.index')}}
                            </div>
                            <div class="i-hl-points-tier--title">
                              {{$t('points.highlow.tier-illustration.tier-one.title')}}
                            </div>
                            <div class="i-hl-points-tier--desc">

                              <b>{{$t('points.highlow.tier-illustration.tier-one.desc.main')}}</b> 
                              <p v-html="$t('points.highlow.tier-illustration.tier-one.desc.extra')"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="i-hl-points-tier i-hl-points-tier__2">
                      <div class="p-css-table p-css-table__fill">
                        <div class="p-css-table-row">
                          <div class="p-css-table-cell p-css-table-cell__center">
                            <div class="i-hl-points-tier--index">
                              {{$t('points.highlow.tier-illustration.tier-two.index')}}
                            </div>
                            <div class="i-hl-points-tier--title">
                              {{$t('points.highlow.tier-illustration.tier-two.title')}}
                            </div>
                            <div class="i-hl-points-tier--desc">
                              <b>{{$t('points.highlow.tier-illustration.tier-two.desc.main')}}</b> 
                              <p v-html="$t('points.highlow.tier-illustration.tier-two.desc.extra')"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="i-hl-points-tier i-hl-points-tier__3">
                      <div class="p-css-table p-css-table__fill">
                        <div class="p-css-table-row">
                          <div class="p-css-table-cell p-css-table-cell__center">
                            <div class="i-hl-points-tier--index">
                              {{$t('points.highlow.tier-illustration.tier-three.index')}}
                            </div>
                            <div class="i-hl-points-tier--title">
                              {{$t('points.highlow.tier-illustration.tier-three.title')}}
                            </div>
                            <div class="i-hl-points-tier--desc">
                              <b>{{$t('points.highlow.tier-illustration.tier-three.desc.main')}}</b> 
                              <p v-html="$t('points.highlow.tier-illustration.tier-three.desc.extra')"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="i-hl-points-tier i-hl-points-tier__4">
                      <div class="p-css-table p-css-table__fill">
                        <div class="p-css-table-row">
                          <div class="p-css-table-cell p-css-table-cell__center">
                            <div class="i-hl-points-tier--index">
                              {{$t('points.highlow.tier-illustration.tier-four.index')}}
                            </div>
                            <div class="i-hl-points-tier--title">
                              {{$t('points.highlow.tier-illustration.tier-four.title')}}
                            </div>
                            <div class="i-hl-points-tier--desc">
                              <b>{{$t('points.highlow.tier-illustration.tier-four.desc.main')}}</b> 
                              <p v-html="$t('points.highlow.tier-illustration.tier-four.desc.extra')"></p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-horizontal-full-width-tab--block p-horizontal-full-width-tab--block__alternate-bg">
                <div class="p-container">
                  <h2 class="p-horizontal-full-width-tab--tab--heading">
                    {{$t('points.highlow.title-2')}}
                  </h2>
                  <p class="p-horizontal-full-width-tab--tab--body-text">
                    {{$t('points.highlow.content-2')}}
                  </p>
                  <div id="i-hl-points-cashback-converter" class="i-hl-points-cashback-converter"
                    data-rules="[[0,9999,0,10],[10000,19999,3,10],[20000,49999,5,10],[50000,0,10,10]]" data-max="50000"
                    data-point-to-cash-rate="0.01">
                    <div class="i-hl-points-cashback-converter--headers">
                      <div class="i-hl-points-cashback-converter--header" id="i-hl-points-cashback-converter--header-1">
                        {{$t('points.cashbacks.widget.volume-header')}}
                      </div>
                      <div class="i-hl-points-cashback-converter--header" id="i-hl-points-cashback-converter--header-2">
                        {{$t('points.cashbacks.widget.point-header')}}
                      </div>
                      <div class="i-hl-points-cashback-converter--header" id="i-hl-points-cashback-converter--header-3">
                        {{$t('points.cashbacks.widget.cashback-header')}}
                      </div>
                    </div>
                    <div class="i-hl-points-cashback-converter--bodies">
                      <div class="i-hl-points-cashback-converter--body" id="i-hl-points-cashback-converter--body-1">
                        <div id="i-hl-points-cashback-converter--knob-control">
                          <div id="i-hl-points-cashback-converter--slug">
                            {{$t('points.try')}}
                          </div>
                          <img src="@/assets/images/knob-shadow.png" id="i-hl-points-cashback-converter--knob-shadow">
                          <div id="i-hl-points-cashback-converter--knob">
                          </div>
                          <span class="i-hl-points-cashback-converter--knob--label"
                            id="i-hl-points-cashback-converter--knob--min">
                            $0
                          </span>
                          <span class="i-hl-points-cashback-converter--knob--label"
                            id="i-hl-points-cashback-converter--knob--max">
                            $50k+
                          </span>
                        </div>
                      </div>
                      <div class="i-hl-points-cashback-converter--body" id="i-hl-points-cashback-converter--body-2">
                        <div id="i-hl-points-cashback-converter--progress">
                          <div class="highlow-point-progress-text clearfix">
                            <div class="highlow-point-progress-current-tier">
                              <label v-html="$t('points.cashbacks.widget.volume-label')">
                              </label>
                              <div class="highlow-point-progress-current-points-value "
                                id="i-hl-points-cashback-converter--progress--volume" data-currency="$">
                                $0
                              </div>
                            </div>
                            <div class="highlow-point-progress-current-points">
                              <label v-html="$t('points.cashbacks.widget.point-label')">
                              </label>
                              <div class="highlow-point-progress-current-points-value "
                                id="i-hl-points-cashback-converter--progress--points">
                                0
                              </div>
                            </div>
                          </div>
                          <div class="highlow-point-progress">
                            <div class="highlow-point-progress-bar">
                              <div class="highlow-point-progress-bar-fill">
                                <div class="highlow-point-progress-tier highlow-point-progress-player"
                                  id="i-hl-points-cashback-converter--progress--player">
                                  <label>
                                    {{$t('points.cashbacks.widget.tier-label.player')}}
                                  </label>
                                </div>
                                <div class="highlow-point-progress-tier highlow-point-progress-trader"
                                  id="i-hl-points-cashback-converter--progress--trader">
                                  <label>
                                    {{$t('points.cashbacks.widget.tier-label.trader')}}
                                  </label>
                                </div>
                                <div class="highlow-point-progress-tier highlow-point-progress-pro"
                                  id="i-hl-points-cashback-converter--progress--pro">
                                  <label>
                                    {{$t('points.cashbacks.widget.tier-label.pro')}}
                                  </label>
                                </div>
                                <div class="highlow-point-progress-tier highlow-point-progress-elite"
                                  id="i-hl-points-cashback-converter--progress--elite">
                                  <label>
                                    {{$t('points.cashbacks.widget.tier-label.elite')}}
                                  </label>
                                </div>
                                <div class="cover" id="i-hl-points-cashback-converter--progress--bar">
                                  <span class="pointer"></span>
                                </div>
                              </div>
                              <div class="highlow-point-progress-bar-dividers">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="i-hl-points-cashback-converter--body" id="i-hl-points-cashback-converter--header-3">
                        <div id="i-hl-points-cashback-converter--cashback"> $0 </div>
                        <div class="i-hl-points-cashback-converter--body--caption" v-html="$t('points.cashbacks.widget.cashback-info')">
                        </div>
                      </div>
                    </div>
                  </div> <a class="p-click-scroll-to toggler p-horizontal-full-width-tab__hl-points--switch-toggle"
                    data-click-also="#about-cashback-selector" data-click-scroll-to-target="#i-hl-cashback-points-tabs"
                    data-click-scroll-to-duration="125">
                    {{$t('points.cashback-link')}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


  </fragment>
</template>

<script>
  var $ = require('jquery');
  import utils from '../../jquery/utils'

  export default {
    mounted: function () {
      this.$nextTick(function () {
        this.knobKnob()
        this.cashbackExplain()
        this.HLPointsCashbackConverter()
      })
    },
    methods: {
      knobKnob() {
        $.fn.knobKnob = function (b) {
          var c = $.extend({
            snap: 0,
            value: 0,
            max: 359,
            minLabel: "",
            maxLabel: "",
            turn: function () {}
          }, b || {});
          return this.each(function () {
            var b = $(this);
            b.append(
              '<div class="knob">\t\t\t\t<div class="top"></div>\t\t\t\t<div class="base"></div>\t\t\t</div>');
            var d = $(".knob", b),
              e = d.find(".top"),
              f = -1,
              g = 0,
              h = 0,
              i = 0,
              j = $(document);
            c.value > 0 && c.value <= c.max && (h = i = g = c.value, e.css("transform", "rotate(" + g + "deg)"), c
              .turn(g / 359, g)), d.on("mousedown touchstart", function (a) {
              a.preventDefault();
              var b, k, l, m, n = d.offset(),
                o = {
                  y: n.top + d.height() / 2,
                  x: n.left + d.width() / 2
                },
                p = 180 / Math.PI;
              d.on("mousemove.rem touchmove.rem", function (a) {
                if (a = a.originalEvent.touches ? a.originalEvent.touches[0] : a, b = o.y - a.pageY, k = o
                  .x - a.pageX, l = Math.atan2(b, k) * p, l < 0 && (l = 360 + l), -1 == f && (f = l), m =
                  Math.floor(l - f + h), m < 0 ? m = 360 + m : m > 359 && (m %= 360), c.snap && m < c
                  .snap && (m = 0), c.max && m > c.max && (m = c.max), Math.abs(m - i) > 180) return !1;
                g = m, i = m, e.css("transform", "rotate(" + g + "deg)"), c.turn(g / 360, g)
              }), j.on("mouseup.rem  touchend.rem", function () {
                d.off(".rem"), j.off(".rem"), h = g, f = -1
              })
            }), $(c.minLabel).click(function () {
              h = i = g = 0, e.css("transform", "rotate(" + g + "deg)"), c.turn(g / 359, g)
            }), $(c.maxLabel).click(function () {
              h = i = g = c.max, e.css("transform", "rotate(" + g + "deg)"), c.turn(g / 359, g)
            })
          })
        }
      },
      cashbackExplain() {
        function a() {
          0 == $("#country_code_idr").length ? $("#i-cashback-cashback-amount").html(utils.getDisplayMoney(w + v)) : $(
              "#i-cashback-cashback-amount").html(utils.getDisplayMoneyIDR(w + v)), c.removeClass("active"), d
            .removeClass("active"), e.removeClass("active"), 0 == $("#country_code_idr").length ? (f.removeClass(
              "fade faded highlight").html(x.replace("{s}", utils.getDisplayMoney(w + t))), g.removeClass(
              "fade faded highlight").html(y.replace("{s}", utils.getDisplayMoney(w + u))), h.removeClass(
              "fade faded highlight").html(z.replace("{s}", utils.getDisplayMoney(w + v)))) : (f.removeClass(
              "fade faded highlight").html(x.replace("{s}", utils.getDisplayMoneyIDR(w + t))), g.removeClass(
              "fade faded highlight").html(y.replace("{s}", utils.getDisplayMoneyIDR(w + u))), h.removeClass(
              "fade faded highlight").html(z.replace("{s}", utils.getDisplayMoneyIDR(w + v)))), i.removeClass(
              "fade faded"), o.removeClass("hide-away"), k.removeClass("active lost").attr("style", ""), l.removeClass(
              "active").attr("style", ""), 0 == $("#country_code_idr").length ? (m.html(utils.getDisplayMoney(w + t)), n
              .removeClass("highlight").html(utils.getDisplayMoney(w + u))) : (m.html(utils.getDisplayMoneyIDR(w + t)),
              n.removeClass("highlight").html(utils.getDisplayMoneyIDR(w + u))), q.removeClass("collapsed"), r
            .removeClass("collapsed"), e.removeClass("collapsed active win lose"), s.removeClass("active"), 0 == $(
              "#country_code_idr").length ? p.html(utils.getDisplayMoney(w + v)) : p.html(utils.getDisplayMoneyIDR(w +
              v))
        }

        function b() {
          K = setInterval(function () {
            var a = $($(".i-cashback-slide-show--slides-selector.active").next(
              ".i-cashback-slide-show--slides-selector"));
            a.length > 0 ? a.click() : $(".i-cashback-slide-show--slides-selector:nth-child(1)").click()
          }, $(".i-cashback-slide-show").data("interval"))
        }
        if (!($("#i-cashback-explain-widget").length <= 0)) {
          var c = $(".i-cashback-explain-widget--interactive-block--button.win"),
            d = $(".i-cashback-explain-widget--interactive-block--button.lose"),
            e = $(".i-cashback-explain-widget"),
            f = $("#i-cashback-caption-1"),
            g = $("#i-cashback-caption-2"),
            h = $("#i-cashback-caption-3"),
            i = $("#i-cashback-caption-4"),
            j = $("#i-cashback-circle-1"),
            k = ($("#i-cashback-circle-2"), $("#i-cashback-circle-3")),
            l = $("#i-cashback-circle-4"),
            m = $("#i-cashback-money-1"),
            n = $("#i-cashback-money-2"),
            o = $("#i-cashback-explain-widget--trade-body--rate"),
            p = $("#i-cashback-explain-widget--trade-body--money"),
            q = ($("#i-cashback-explain-widget--trade-body--graphic-item--graphic"), $(
              "#i-cashback-explain-widget--trade-heading")),
            r = $("#i-cashback-explain-widget--trade-body"),
            s = ($("#i-cashback-explain-widget--interactive-block"), $("#i-cashback-reset")),
            t = parseInt(e.data("startAccount")),
            u = parseInt(e.data("cashback")),
            v = parseInt(e.data("trade")),
            w = e.data("currency"),
            x = e.data("startAccountCaption"),
            y = e.data("cashbackCaption"),
            z = e.data("tradeCaption"),
            A = e.data("tradeWonCaption"),
            B = e.data("tradeLostCaption"),
            C = e.data("tradeEffectWonCaption"),
            D = e.data("tradeEffectLostCaption"),
            E = e.data("accountAfterTradeWonCaption"),
            F = e.data("accountAfterTradeLostCaption"),
            G = e.data("cashbackEffectCaption"),
            H = e.data("accountFinalCaption"),
            I = e.data("cashbackFinalCaption"),
            J = C;
          s.click(function () {
            a()
          }), c.click(function () {
            e.hasClass("active") || (c.addClass("active"), e.addClass("active win"), f.addClass("fade"), g.addClass(
              "fade"), i.addClass("fade"), 0 == $("#country_code_idr").length ? h.addClass("highlight").html(A
              .replace("{s}", utils.getDisplayMoney(w + v))) : h.addClass("highlight").html(A.replace("{s}",
              utils.getDisplayMoneyIDR(w + v))), o.addClass("hide-away"), k.addClass("active"), setTimeout(
              function () {
                f.addClass("faded"), g.addClass("faded"), i.addClass("faded"), setTimeout(function () {
                  h.addClass("faded");
                  var a = j.offset().left - k.offset().left,
                    b = j.offset().top - k.offset().top;
                  k.css({
                      left: a,
                      top: b
                    }), 0 == $("#country_code_idr").length ? f.html(C.replace("{s}", utils.getDisplayMoney(
                      w + v))).removeClass("fade faded").addClass("highlight") : f.html(C.replace("{s}",
                      utils.getDisplayMoneyIDR(w + v))).removeClass("fade faded").addClass("highlight"),
                    setTimeout(function () {
                      k.css({
                        opacity: 0,
                        "-webkit-transform": "scale(0)",
                        "-moz-transform": "scale(0)",
                        "-ms-transform": "scale(0)",
                        "-o-transform": "scale(0)",
                        transform: "scale(0)"
                      }), setTimeout(function () {
                        0 == $("#country_code_idr").length ? (m.html(utils.getDisplayMoney(w +
                          parseInt(t + v))), f.html(E.replace("{s}", utils.getDisplayMoney(w +
                          parseInt(t + v))))) : (m.html(utils.getDisplayMoneyIDR(w + parseInt(t +
                          v))), f.html(E.replace("{s}", utils.getDisplayMoneyIDR(w + parseInt(t +
                          v))))), setTimeout(function () {
                          q.addClass("collapsed"), r.addClass("collapsed"), e.addClass(
                            "collapsed"), setTimeout(function () {
                            l.addClass("active"), f.addClass("faded"), g.removeClass(
                              "fade faded").addClass("highlight").html(G), setTimeout(
                              function () {
                                var a = j.offset().left - l.offset().left,
                                  b = j.offset().top - l.offset().top;
                                l.css({
                                    left: a,
                                    top: b
                                  }), 0 == $("#country_code_idr").length ? (f.removeClass(
                                    "fade faded").addClass("highlight").html(J.replace(
                                    "{s}", utils.getDisplayMoney(w + v))), g.addClass(
                                    "faded"), n.removeClass("highlight").addClass(
                                    "deducted").html(utils.getDisplayMoney(w + parseInt(
                                    u - v)))) : (f.removeClass("fade faded").addClass(
                                      "highlight").html(J.replace("{s}", utils
                                      .getDisplayMoneyIDR(w + v))), g.addClass("faded"), n
                                    .removeClass("highlight").addClass("deducted").html(
                                      utils.getDisplayMoneyIDR(w + parseInt(u - v)))),
                                  setTimeout(function () {
                                    l.css({
                                      opacity: 0,
                                      "-webkit-transform": "scale(0)",
                                      "-moz-transform": "scale(0)",
                                      "-ms-transform": "scale(0)",
                                      "-o-transform": "scale(0)",
                                      transform: "scale(0)"
                                    }), setTimeout(function () {
                                      0 == $("#country_code_idr").length ? m.html(
                                        utils.getDisplayMoney(w + parseInt(t + v +
                                          v))) : m.html(utils.getDisplayMoneyIDR(w +
                                        parseInt(t + v + v))), n.removeClass(
                                        "deducted").addClass("highlight"), 0 == $(
                                        "#country_code_idr").length ? (f
                                        .removeClass("fade faded").addClass(
                                          "highlight").html(H.replace("{s}", utils
                                          .getDisplayMoney(w + parseInt(t + v +
                                            v)))), g.removeClass("fade faded")
                                        .addClass("highlight").html(I.replace("{s}",
                                          utils.getDisplayMoney(w + parseInt(u -
                                            v))))) : (f.removeClass("fade faded")
                                        .addClass("highlight").html(H.replace("{s}",
                                          utils.getDisplayMoneyIDR(w + parseInt(
                                            t + v + v)))), g.removeClass(
                                          "fade faded").addClass("highlight").html(I
                                          .replace("{s}", utils.getDisplayMoneyIDR(
                                            w + parseInt(u - v))))), setTimeout(
                                        function () {
                                          s.addClass("active")
                                        }, 500)
                                    }, 1e3)
                                  }, 1500)
                              }, 1500)
                          }, 1500)
                        }, 1500)
                      }, 1e3)
                    }, 1500)
                }, 750)
              }, 500))
          }), d.click(function () {
            e.hasClass("active") || (d.addClass("active"), e.addClass("active lose"), f.addClass("fade"), g
              .addClass("fade"), i.addClass("fade"), 0 == $("#country_code_idr").length ? h.addClass("highlight")
              .html(B.replace("{s}", utils.getDisplayMoney(w + v))) : h.addClass("highlight").html(B.replace(
                "{s}", utils.getDisplayMoneyIDR(w + v))), o.addClass("hide-away"), k.addClass("active lost"), 0 ==
              $("#country_code_idr").length ? p.html("-" + utils.getDisplayMoney(w + v)) : p.html("-" + utils
                .getDisplayMoneyIDR(w + v)), setTimeout(function () {
                f.addClass("faded"), g.addClass("faded"), i.addClass("faded"), setTimeout(function () {
                  h.addClass("faded");
                  var a = j.offset().left - k.offset().left,
                    b = j.offset().top - k.offset().top;
                  k.css({
                      left: a,
                      top: b
                    }), 0 == $("#country_code_idr").length ? f.html(D.replace("{s}", utils.getDisplayMoney(
                      w + v))).removeClass("fade faded").addClass("highlight") : f.html(D.replace("{s}",
                      utils.getDisplayMoneyIDR(w + v))).removeClass("fade faded").addClass("highlight"),
                    setTimeout(function () {
                      k.css({
                        opacity: 0,
                        "-webkit-transform": "scale(0)",
                        "-moz-transform": "scale(0)",
                        "-ms-transform": "scale(0)",
                        "-o-transform": "scale(0)",
                        transform: "scale(0)"
                      }), setTimeout(function () {
                        0 == $("#country_code_idr").length ? (m.html(utils.getDisplayMoney(w +
                          parseInt(t - v))), f.html(F.replace("{s}", utils.getDisplayMoney(w +
                          parseInt(t - v))))) : (m.html(utils.getDisplayMoneyIDR(w + parseInt(t -
                          v))), f.html(F.replace("{s}", utils.getDisplayMoneyIDR(w + parseInt(t -
                          v))))), setTimeout(function () {
                          q.addClass("collapsed"), r.addClass("collapsed"), e.addClass(
                            "collapsed"), setTimeout(function () {
                            l.addClass("active"), f.addClass("faded"), g.removeClass(
                              "fade faded").addClass("highlight").html(G), setTimeout(
                              function () {
                                var a = j.offset().left - l.offset().left,
                                  b = j.offset().top - l.offset().top;
                                l.css({
                                    left: a,
                                    top: b
                                  }), 0 == $("#country_code_idr").length ? (f.removeClass(
                                    "fade faded").addClass("highlight").html(J.replace(
                                    "{s}", utils.getDisplayMoney(w + v))), g.addClass(
                                    "faded"), n.removeClass("highlight").addClass(
                                    "deducted").html(utils.getDisplayMoney(w + parseInt(
                                    u - v)))) : (f.removeClass("fade faded").addClass(
                                      "highlight").html(J.replace("{s}", utils
                                      .getDisplayMoneyIDR(w + v))), g.addClass("faded"), n
                                    .removeClass("highlight").addClass("deducted").html(
                                      utils.getDisplayMoneyIDR(w + parseInt(u - v)))),
                                  setTimeout(function () {
                                    l.css({
                                      opacity: 0,
                                      "-webkit-transform": "scale(0)",
                                      "-moz-transform": "scale(0)",
                                      "-ms-transform": "scale(0)",
                                      "-o-transform": "scale(0)",
                                      transform: "scale(0)"
                                    }), setTimeout(function () {
                                      0 == $("#country_code_idr").length ? (m.html(
                                            utils.getDisplayMoney(w + parseInt(t))), n
                                          .removeClass("deducted").addClass(
                                            "highlight"), f.removeClass("fade faded")
                                          .addClass("highlight").html(H.replace("{s}",
                                            utils.getDisplayMoney(w + parseInt(t)))),
                                          g.removeClass("fade faded").addClass(
                                            "highlight").html(I.replace("{s}", utils
                                            .getDisplayMoney(w + parseInt(u - v))))) :
                                        (m.html(utils.getDisplayMoneyIDR(w + parseInt(
                                            t))), n.removeClass("deducted").addClass(
                                            "highlight"), f.removeClass("fade faded")
                                          .addClass("highlight").html(H.replace("{s}",
                                            utils.getDisplayMoneyIDR(w + parseInt(
                                              t)))), g.removeClass("fade faded")
                                          .addClass("highlight").html(I.replace("{s}",
                                            utils.getDisplayMoneyIDR(w + parseInt(
                                              u - v))))), setTimeout(function () {
                                          s.addClass("active")
                                        }, 500)
                                    }, 1e3)
                                  }, 1500)
                              }, 1500)
                          }, 1500)
                        }, 1500)
                      }, 1e3)
                    }, 1500)
                }, 750)
              }, 500))
          });
          var K;
          b(), $(".i-cashback-slide-show--slides-selector").click(function () {
            clearInterval(K), setTimeout(function () {
              b()
            }, $(".i-cashback-slide-show").data("interval"))
          }), a()
        }
      },
      HLPointsCashbackConverter() {
        if ($("#i-hl-points-cashback-converter").length > 0) {
          var a = $("#i-hl-points-cashback-converter"),
            b = $("#i-hl-points-cashback-converter--knob"),
            c = $("#i-hl-points-cashback-converter--progress--volume"),
            d = $("#i-hl-points-cashback-converter--progress--points"),
            e = $("#i-hl-points-cashback-converter--progress--bar"),
            f = $("#i-hl-points-cashback-converter--cashback"),
            g = ($("#i-hl-points-cashback-converter--knob--min"), $("#i-hl-points-cashback-converter--knob--max"), c
              .data("currency")),
            h = a.data("max"),
            i = a.data("rules"),
            j = a.data("pointToCashRate");
          console.log("HL Points Rules:"), console.log(i), b.knobKnob({
            snap: 0,
            value: 0,
            max: 252,
            minLabel: "#i-hl-points-cashback-converter--knob--min",
            maxLabel: "#i-hl-points-cashback-converter--knob--max",
            turn: function (a, b) {
              var k = Math.ceil(b / 252 * i[i.length - 1][0]);
              c.html(g + k);
              for (var l = 0, m = 0, n = 0; n < i.length; n++) {
                var o = i[n];
                if (console.log("tier end: " + o[1]), 0 == o[1]) {
                  l = h, console.log(l), m = 100;
                  break
                }
                if (console.log("not null"), k >= o[1] && (m += 25), k >= o[0] && k < o[1]) {
                  console.log(o[3] + "," + o[2]), l = Math.floor(k / o[3] * o[2]), console.log(k + "/" + o[3] +
                    "*" + o[2] + "=" + l), m += parseInt(k - o[0] + 1) / parseInt(o[1] - o[0] + 1) * 25;
                  break
                }
              }
              l > h && (l = h), 100 != m ? (e.removeClass("full"), e.css({
                width: 100 - m + "%"
              })) : e.addClass("full"), d.html(l), f.html(g + Math.floor(l * j))
            }
          })
        }
      }

    }
  }
</script>